import React, { ReactElement, useContext } from 'react';
import { FormsContext } from '../../context/FormsContext';
import WildcardTextInput, {
  WildcardInputPreviewModes,
  WildcardInputQuestionTypes,
} from '../FormsDrafting/WildcardInputs/WildcardTextInput';
import { Box, Flex } from '@televet/kibble-ui/build/chakra';

function DefaultFields(): ReactElement {
  const { formName, introMessage } = useContext(FormsContext);

  return (
    <Flex flex={1} flexDirection="column">
      <Flex
        as="p"
        fontSize="2xl"
        fontWeight={600}
        justifyContent="space-between"
        textAlign="center"
        p="28px"
        bg="background.default"
        mb="5px"
      >
        {formName}
      </Flex>
      {introMessage && (
        <Box fontSize="lg" fontWeight={600} m="20px 50px">
          <WildcardTextInput
            text={introMessage}
            type={WildcardInputQuestionTypes.Intro}
            previewMode={WildcardInputPreviewModes.Form}
          />
        </Box>
      )}
    </Flex>
  );
}

export default DefaultFields;
